export enum TypeButtonPPV {
  AUDIO = 'audio',
  DEFAULT = 'default',
}
